import type { TFmxSummary } from '../../../../react-query/useFmxSummaries';
import { useUniversalToFDI } from '../../../../utils/internationalization/useUniversalToFDI';

export const useGenerateFindingsCounts = () => {
  const { displayToothNumber } = useUniversalToFDI();

  const generateFindingsCounts = (fmxSummary?: TFmxSummary) => {
    if (!fmxSummary) {
      return null;
    }

    const restoCounts = Object.entries(fmxSummary?.summary || {})
      .filter(
        ([, finding]) =>
          finding?.deepestCariesDepth &&
          finding?.deepestCariesDepth !== 'unknown',
      )
      .reduce(
        (counts, [tooth]) => {
          const localizedTooth = displayToothNumber(tooth);
          const newCounts = { ...counts };
          if (localizedTooth === 'Unknown') {
            newCounts.hasUnknown = true;
          } else {
            newCounts.pathologyCount += 1;
            newCounts.toothNumbers.push(tooth);
          }
          return newCounts;
        },
        {
          pathologyCount: 0,
          hasUnknown: false,
          toothNumbers: [] as string[],
        },
      );

    const perioCounts = [
      fmxSummary?.quadSummary?.UR,
      fmxSummary?.quadSummary?.UL,
      fmxSummary?.quadSummary?.LL,
      fmxSummary?.quadSummary?.LR,
    ].map((value) => {
      let severity = 'normal';
      if (value?.rblSeverities?.yellow) {
        severity = 'mild';
      }
      if (value?.rblSeverities?.orange) {
        severity = 'moderate';
      }
      if (value?.rblSeverities?.red) {
        severity = 'severe';
      }
      return severity;
    });
    return {
      perioAllQuadrants: perioCounts,
      allRestoFindingCounts: restoCounts,
    };
  };
  return { generateFindingsCounts };
};
